(function () {
  var form = document.querySelector('form[data-product-form]');
  var box = document.querySelector('[data-addons]');
  if (!form || !box || !window.fetch) return;

  form.addEventListener('submit', function (e) {
    var extras = Array.prototype.map.call(
      box.querySelectorAll('[data-addon-yes]:checked'),
      function (i) { return { id: Number(i.value), quantity: 1 }; }
    );
    if (!extras.length) return; // nothing picked: normal Add to cart

    e.preventDefault();
    var id = Number(form.querySelector('input[name="id"]').value);
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = Math.max(1, Number(qtyEl && qtyEl.value) || 1);
    var btn = form.querySelector('[data-add-btn]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }].concat(extras) })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function () { form.submit(); });
  });
})();
